import { action } from 'typesafe-actions'
import { INewReportRequest, ReportTypes } from './types'
import IntradayHeartRate from '../../../application/models/time.series/intraday/heart.rate/intraday.heart.rate'
import TimeSeries from '../../../application/models/time.series/time.series'
import Report from '../../../application/models/report/report'
import { IAxiosResponse, IPaginator } from '../../root.types'
import Sleep from '../../../application/models/activity/sleep/sleep'
import { TimeSeriesSimpleFilter } from '../../../application/models/time.series/filters/simple.filter'

import Comorbidity from '../../../application/models/medical.indicator/comorbidities'
import Medicament from '../../../application/models/medical.indicator/medicament'

export const reset = () => action(ReportTypes.RESET)

/* Actions for load steps*/

export const loadStepsRequest = (patientId: string, startDate: Date, endDate: Date, type: 'previous' | 'current') => action(
    ReportTypes.LOAD_STEPS_REQUEST,
    { patientId, startDate, endDate, type })


export const loadStepsSuccess = (data: TimeSeries, type: 'previous' | 'current') => action(
    ReportTypes.LOAD_STEPS_SUCCESS, { data, type }
)

export const loadStepsFailure = (type: 'previous' | 'current') => action(
    ReportTypes.LOAD_STEPS_FAILURE,
    { type }
)

/* Actions for load active minutes */

export const loadActiveMinutesRequest = (patientId: string, startDate: Date, endDate: Date, type: 'previous' | 'current') => action(
    ReportTypes.LOAD_ACTIVE_MINUTES_REQUEST,
    { patientId, startDate, endDate, type }
)


export const loadActiveMinutesSuccess = (data: TimeSeries, type: 'previous' | 'current') => action(
    ReportTypes.LOAD_ACTIVE_MINUTES_SUCCESS,
    { data, type }
)

export const loadActiveMinutesFailure = (type: 'previous' | 'current') => action(
    ReportTypes.LOAD_ACTIVE_MINUTES_FAILURE,
    { type }
)

/* Actions for load heart rate */

export const loadHeartRateRequest = (patientId: string, startDate: Date, endDate: Date, type: 'previous' | 'current') => action(
    ReportTypes.LOAD_HEART_RATE_REQUEST,
    { patientId, startDate, endDate, type }
)

export const loadHeartRateSuccess = (data: IntradayHeartRate[], type: 'previous' | 'current') => action(
    ReportTypes.LOAD_HEART_RATE_SUCCESS,
    { data, type }
)

export const loadHeartRateFailure = (type: 'previous' | 'current') => action(
    ReportTypes.LOAD_HEART_RATE_FAILURE,
    { type }
)

/* Actions for load sleep */
export const loadSleepRequest = (
    patientId: string,
    startDate: Date,
    endDate: Date,
    type: 'previous' | 'current'
) => action(
    ReportTypes.LOAD_SLEEP_REQUEST,
    { patientId, startDate, endDate, type }
)

export const loadSleepSuccess = (data: Sleep[], type: 'previous' | 'current') => action(
    ReportTypes.LOAD_SLEEP_SUCCESS,
    { data, type }
)

export const loadSleepFailure = (type: 'previous' | 'current') => action(
    ReportTypes.LOAD_SLEEP_FAILURE,
    { type }
)


export const changeDialog = (dialog: boolean) => {
    const array: any[] = [action(ReportTypes.CHANGE_DIALOG, { dialog })]
    if (dialog) {
        array.push(resetReportView())
    }
    return array
}

/* Actons Store temporary report information*/
export const newReportRequest = (report: INewReportRequest) => action(ReportTypes.NEW_REPORT_REQUEST, report)

/* Actions to create a report */
export const createReportRequest = (report: Report) => action(ReportTypes.CREATE_REPORT_REQUEST, { report })

export const createReportSuccess = (report: Report) => action(ReportTypes.CREATE_REPORT_SUCCESS, { report })

export const createReportFailure = () => action(ReportTypes.CREATE_REPORT_FAILURE)

export const changeReportView = (field: string, value: boolean) => action(ReportTypes.CHANGE_REPORT_VIEW, {
    field, value
})

export const resetReportView = () => action(ReportTypes.RESET_REPORT_VIEW)

/* Actions to load reports */
export const loadReportRequest = (patientId: string, paginator?: IPaginator, filter?: TimeSeriesSimpleFilter) => action(
    ReportTypes.LOAD_REPORT_REQUEST,
    { patientId, paginator, filter }
)

export const loadReportSuccess = (response: IAxiosResponse<Report[]>) => action(ReportTypes.LOAD_REPORT_SUCCESS, response)

export const loadReportFailure = () => action(ReportTypes.LOAD_REPORT_FAILURE)

export const changeListPaginator = (
    patientId: string,
    paginator?: IPaginator,
    filter?: TimeSeriesSimpleFilter
) => [
        action(ReportTypes.CHANGE_PAGINATOR, { patientId, paginator }),
        loadReportRequest(patientId, paginator, filter)
    ]

export const loadMoreRequest = (
    patientId: string,
    paginator?: IPaginator,
    filter?: TimeSeriesSimpleFilter
) => action(
    ReportTypes.LOAD_MORE_REQUEST,
    { patientId, paginator, filter }
)

export const loadMoreSuccess = (response: IAxiosResponse<Report[]>) => action(
    ReportTypes.LOAD_MORE_SUCCESS,
    {
        data: response.data,
        headers: response.headers
    }
)

export const loadMoreFailure = () => action(ReportTypes.LOAD_MORE_FAILURE)

/* Actions for report remove */
export const changeDialogRemove = (dialog: boolean, ids: string[]) => action(
    ReportTypes.CHANGE_DIALOG_REMOVE,
    { dialog, ids }
)

export const removeReportRequest = (patientId: string, ids: string[]) => action(
    ReportTypes.REMOVE_REPORT_REQUEST,
    { patientId, ids }
)

export const removeReportSuccess = (ids: string[]) => action(
    ReportTypes.REMOVE_REPORT_SUCCESS,
    { ids }
)

export const removeReportFailure = () => action(ReportTypes.REMOVE_REPORT_FAILURE)

/* Actions for load medical indicators */

export const loadMedicalIndicatorsRequest = (patientId: string) => action(
    ReportTypes.LOAD_MEDICAL_INDICATORS_REQUEST,
    { patientId }
)

/* Actions for load comorbidities*/

export const loadComorbiditiesSuccess = (data: Comorbidity) => action(
    ReportTypes.LOAD_COMORBIDITY_SUCCESS,
    { data }
)

export const loadComorbiditiesFailure = () => action(ReportTypes.LOAD_COMORBIDITY_FAILURE)

/* Actions for load medicaments*/

export const loadMedicamentsSuccess = (data: Medicament) => action(ReportTypes.LOAD_MEDICAMENT_SUCCESS, { data })

export const loadMedicamentsFailure = () => action(ReportTypes.LOAD_MEDICAMENT_FAILURE)
